import React from 'react'
import { WhatsAppTextProps } from './whatsapp-text.type'
import styles from './whatsapp-text.module.css'

export const WhatsAppText = ({ text, className }: WhatsAppTextProps) => {
  if (!text) return null

  const formatText = (inputText: string): React.ReactNode[] => {
    const lines = inputText.split('\n')
    const result: React.ReactNode[] = []

    lines.forEach((line, lineIndex) => {
      if (lineIndex > 0) {
        result.push(<br key={`br-${lineIndex}`} />)
      }

      let remainingText = line
      const lineElements: React.ReactNode[] = []
      let elementKey = 0

      while (remainingText.length > 0) {
        const variableMatch = remainingText.match(/^(\{\{[^}]+\}\})/)
        if (variableMatch) {
          lineElements.push(
            <span
              key={`var-${lineIndex}-${elementKey++}`}
              className={styles.variable}
            >
              {variableMatch[1]}
            </span>,
          )
          remainingText = remainingText.slice(variableMatch[1].length)
          continue
        }

        const boldMatch = remainingText.match(/^\*([^*]+)\*/)
        if (boldMatch) {
          lineElements.push(
            <strong key={`bold-${lineIndex}-${elementKey++}`}>
              {boldMatch[1]}
            </strong>,
          )
          remainingText = remainingText.slice(boldMatch[0].length)
          continue
        }

        const italicMatch = remainingText.match(/^_([^_]+)_/)
        if (italicMatch) {
          lineElements.push(
            <em key={`italic-${lineIndex}-${elementKey++}`}>
              {italicMatch[1]}
            </em>,
          )
          remainingText = remainingText.slice(italicMatch[0].length)
          continue
        }

        const strikeMatch = remainingText.match(/^~([^~]+)~/)
        if (strikeMatch) {
          lineElements.push(
            <s key={`strike-${lineIndex}-${elementKey++}`}>{strikeMatch[1]}</s>,
          )
          remainingText = remainingText.slice(strikeMatch[0].length)
          continue
        }

        const normalMatch = remainingText.match(/^([^*_~{]+)/)
        if (normalMatch) {
          lineElements.push(
            <span key={`text-${lineIndex}-${elementKey++}`}>
              {normalMatch[1]}
            </span>,
          )
          remainingText = remainingText.slice(normalMatch[1].length)
          continue
        }

        lineElements.push(
          <span key={`char-${lineIndex}-${elementKey++}`}>
            {remainingText[0]}
          </span>,
        )
        remainingText = remainingText.slice(1)
      }

      result.push(...lineElements)
    })

    return result
  }

  return (
    <div className={`${styles.container} ${className || ''}`}>
      {formatText(text)}
    </div>
  )
}
